import { AuthGuard } from './../authentication/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResourcesComponent } from './components/resources/resources.component';

const routes: Routes = [
  {
    path: 'resource-portal',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ResourcesComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResourceRoutingModule { }
